import React from "react";

export const DurationSelection = ({ selectedDuration, onSelectDuration, sessionDurations }) => {
    return (
        <div className="container-fluid px-3">
            <h3 className="text-center text-md-start py-3 pt-md-0">
                Select Session Duration
            </h3>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-2 g-3">
                {sessionDurations.map((slot) => (
                    <div className="col" key={slot.id}>
                        <div 
                            className={`card h-100 cursor-pointer ${selectedDuration?.id === slot.id ? 'border-primary' : ''}`}
                            onClick={() => onSelectDuration(slot)}
                        >
                            <div className="card-body d-flex align-items-center">
                                <input
                                    className="form-check-input me-3"
                                    type="radio"
                                    name="durationRadios"
                                    value={slot.id}
                                    checked={selectedDuration?.id === slot.id}
                                    onChange={() => onSelectDuration(slot)}
                                />
                                <div>
                                    <h5 className="card-title mb-1">{slot.duration} minutes</h5>
                                    <p className="card-text text-muted">
                                        ${slot.price}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};